import type { Permission } from '@pulsepoint/shared';
import { ChartNoAxesColumn, EvCharger, House, List, ReceiptText, Settings, User, type LucideIcon } from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Hidden from people without it. */
  permission?: Permission;
}

/** The sidebar, in the order of the mockups. */
export const NAV: NavItem[] = [
  { label: 'Home', to: '/', icon: House },
  { label: 'Sites and chargers', to: '/sites', icon: EvCharger, permission: 'sites.view' },
  { label: 'Sessions', to: '/sessions', icon: List, permission: 'sessions.view' },
  { label: 'Reports', to: '/reports', icon: ChartNoAxesColumn, permission: 'reports.view' },
  { label: 'Drivers and cards', to: '/drivers', icon: User, permission: 'drivers.view' },
  { label: 'Public charging', to: '/public-charging', icon: ReceiptText, permission: 'billing.view' },
  { label: 'Settings', to: '/settings', icon: Settings },
];
